/*
        SUMMARY
            0 - Imports
            1 - Const / Variables
            2 - Functions
*/

/*---------------------/ 0 - Imports /-------------------*/
import HorizontalSliderPrivacy from '../components/horizontalSliderPrivacy';
require('./home-mobile/modules/contato-dropdown');
document.addEventListener('DOMContentLoaded', () => window.HomeContatoDropdown?.init());

/*---------------------/ 1 - Const - Variables /-------------------*/

/*---------------------/ 2 - Functions /-------------------*/

// Inicializa o slider de privacidade
function initPrivacySlider() {
    // Aguarda os dados estarem disponíveis
    const checkData = setInterval(() => {
        if (typeof window.privacySliderData !== 'undefined' && window.privacySliderData.length > 0) {
            clearInterval(checkData);

            // Inicializa o slider horizontal de privacidade
            if (typeof HorizontalSliderPrivacy !== 'undefined') {
                HorizontalSliderPrivacy(window.privacySliderData);
                console.log('✅ Privacy Horizontal Slider initialized successfully');
            } else if (typeof window.HorizontalSliderPrivacy !== 'undefined') {
                window.HorizontalSliderPrivacy.initializeSlider(window.privacySliderData);
                console.log('✅ Privacy Horizontal Slider initialized successfully');
            }
        }
    }, 100);

    // Timeout de segurança
    setTimeout(() => {
        clearInterval(checkData);
        if (typeof window.privacySliderData === 'undefined') {
            console.warn('⚠️ Privacy slider data not found');
        }
    }, 5000);
}

// Inicializa todos os componentes
function initAll() {
    initPrivacySlider();
}

// Executa quando o DOM estiver pronto
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}
